import {
  FaChartBar,
  FaGlobe,
  FaUser,
  FaMapMarkerAlt,
  FaTrash,
} from "react-icons/fa";
import { HStack, IconButton, Text } from "@chakra-ui/react";

const iconForType = (type: string) => {
  switch (type) {
    case "countries":
      return <FaMapMarkerAlt size={12} color="gray.300" />;
    case "interests":
      return <FaGlobe size={12} color="gray.300" />;
    case "behaviors":
      return <FaUser size={12} color="gray.300" />;
    case "demographics":
      return <FaChartBar size={12} color="gray.300" />;
    case "geo_markets":
      return <FaMapMarkerAlt size={12} color="gray.300" />;
    default:
      return <FaGlobe size={12} color="gray.300" />;
  }
};

const IconWrapper = ({
  item,
  isLoading = false,
  onRemove,
}: {
  item: {
    type: string;
    name: string;
    value?: string;
    key?: string;
  };
  isLoading?: boolean;
  onRemove: (item: {
    type: any;
    name: string;
    value?: string;
    key?: string;
  }) => void;
}) => (
  <HStack gap={2} rounded={"lg"} p={2} backgroundColor={"gray.100"}>
    <HStack gap={1} flexShrink={0}>
      {iconForType(item.type)}
      <Text fontWeight={"bold"} fontSize="sm" textTransform={"uppercase"}>
        {item.name}
      </Text>
    </HStack>
    <IconButton
      isLoading={isLoading}
      isDisabled={isLoading}
      size={"xs"}
      aria-label="Remove"
      icon={<FaTrash />}
      onClick={() => onRemove(item)}
    />
  </HStack>
);

export default IconWrapper;
